import {Stage, ScreenState } from './Stage';
import { KeyName } from './Style';

class QuizEntry {
    /**
     * @param {Stage} stage - The stage object
     * @param {HTMLCanvasElement} canvas - The canvas element
     */
    constructor(stage, canvas) {
        this.stage = stage;
        console.log("QuizEntry::dpr", stage.dpr);
        console.log("QuizEntry::height: ", stage.height);
        console.log("QuizEntry::width: ", stage.width);
        this.canvas = canvas;
        this.context = canvas.getContext('2d');
        this.button = {
            x: (this.stage.width / 2) - 200,
            y: this.stage.height / 2 - 25,
            width: 200,
            height: 50,
            text: 'Start',
        };
    }    
    draw() {
        this.drawButton();
        this.drawEntry();
        
    }
    drawButton() {
        const { x, y, width, height, text } = this.button;
        this.button.x = (this.stage.width / 2 - 100);
        this.button.y = this.stage.height - 150;
        this.context.fillStyle = this.stage.style.getColor(KeyName.BUTTON_BOX);
        this.context.fillRect(this.button.x, this.button.y, width, height);
        this.context.fillStyle = this.stage.style.getColor(KeyName.BUTTON_TEXT);
        this.context.font = '20px Arial';
        this.context.textAlign = 'center';
        this.context.textBaseline = 'middle';
        this.context.fillText(text, this.button.x + width / 2, this.button.y + height / 2);
    }
    drawEntry() {
        this.context.fillStyle = this.stage.style.getColor(KeyName.QUESTION_TEXT);
        this.context.font = '30px Arial';
        this.context.textAlign = 'center';
        this.context.textBaseline = 'middle';
        this.context.fillText('Cramland', this.stage.width / 2, 50);
    }

    doClick(x, y) {        
        if (
          x >= this.button.x &&
          x <= this.button.x + this.button.width &&
          y >= this.button.y &&
          y <= this.button.y + this.button.height
        ) {
          console.log('Button clicked!');
          this.stage.screenState = ScreenState.QUIZ_TITLE;
        }
      }
};

export default QuizEntry;